"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hexToRGB_1 = __importDefault(require("./hexToRGB"));
// Distance between 2 colors (in RGB)
// https://stackoverflow.com/questions/23990802/find-nearest-color-from-a-colors-list
function distance(a, b) {
    return Math.sqrt(Math.pow(a[0] - b[0], 2)
        + Math.pow(a[1] - b[1], 2)
        + Math.pow(a[2] - b[2], 2));
}
// return nearest color from array
exports.default = (sixDigitHex, baseColors) => {
    let lowest = Number.POSITIVE_INFINITY;
    let index = 0;
    const inputRBG = (0, hexToRGB_1.default)(sixDigitHex);
    baseColors.forEach((el, i) => {
        const lastDistance = distance(inputRBG, (0, hexToRGB_1.default)(el.hex));
        if (lastDistance < lowest) {
            lowest = lastDistance;
            index = i;
        }
    });
    return {
        ...baseColors[index],
        rgb: inputRBG
    };
};
